<template>
  <div class="">
    <div class="mb-8 flex flex-center justify-center button-top">
      <button class="CTAButton bg-transparent" @click="newVendor">
        Add New Vendor
      </button>
    </div>
    <DeleteVendor ref="delUser">
      Are you sure you want to delete this Vendor?
    </DeleteVendor>
    <div
      v-if="isReady"
      ref="gridBox"
      class="gridlist grid-Scroll grid-ScrollList"
    >
      <AgGridVue
        :style="{ width, height }"
        class="ag-theme-fresh"
        :row-height="rowHeight"
        :get-row-height="getRowHeight"
        :default-col-def="defaultColDef"
        :column-defs="columnDefs"
        :pagination="true"
        :pagination-page-size="paginationPageSize"
        :row-data="vendors"
        :modules="modules"
        :row-class-rules="rowClassRules"
        @grid-ready="onGridReady"
      >
      </AgGridVue>
    </div>
    <Spinner v-else />
  </div>
</template>
<script>
import 'ag-grid-community/dist/styles/ag-theme-fresh.css'
import { AgGridVue } from '@ag-grid-community/vue'
import { SetFilterModule } from '@ag-grid-enterprise/set-filter'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel'
import { MenuModule } from '@ag-grid-enterprise/menu'
import { RichSelectModule } from '@ag-grid-enterprise/rich-select'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import Spinner from '../../components/Spinner.vue'
import DeleteVendor from '../../components/Modal/DeleteVendor.vue'

export default {
  components: {
    AgGridVue,
    Spinner,
    DeleteVendor,
  },
  inject: ['store'],
  props: {
    response: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      vendors: [],
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      width: '100%',
      height: '80vh',
      rowSelection: 'multiple',
      rowClassRules: null,
      modules: [
        SetFilterModule,
        ClientSideRowModelModule,
        MenuModule,
        ColumnsToolPanelModule,
        RichSelectModule,
        AllModules,
      ],
      rowHeight: 150,
    }
  },
  computed: {
    isReady() {
      return this.store.assort.vendors
    },
    isAppName() {
      return this.store.user.appName
    },
    isDel() {
      return this.store.user.userDetails
    },
  },
  watch: {
    isReady(newVal, oldVal) {
      if (newVal) {
        this.vendors = this.store.assort.vendors
      }
    },
    isAppName(newVal, oldVal) {
      if (newVal) {
        this.vendors = this.store.assort.vendors
      }
    },
    async isDel(newVal, oldVal) {
      if (newVal) {
        this.vendors = await this.store.assort.fetchVendors()
      }
    },
    response(newVal, oldVal) {
      if (newVal) {
        this.vendors = this.response
      }
    },
  },
  beforeMount() {
    this.gridOptions = {
      // floatingFiltersHeight: 60,
      // headerHeight: 60,
    }
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      filter: 'agTextColumnFilter',
      cellStyle: {
        'background-color': '#E5E5E5',
        'border-bottom': '2px solid #D8D8D8',
        'padding-top': '10px;',
        transform: 'translateY(0px)',
      },
      // filter: 'agTextColumnFilter',
      // floatingFilter: true,
      enableCellTextSelection: true,
    }
    this.paginationPageSize = 10
    this.paginationNumberFormatter = params => {
      return '[' + params.value.toLocaleString() + ']'
    }
    this.vendors = this.store.assort.vendors
    this.columnDefs = [
      {
        headerName: 'Name',
        field: 'fullName',
        width: 150,
      },
      {
        headerName: 'Group',
        // field: 'data.applications[0].name',
        width: 190,
        cellRenderer: this.group.bind(this),
      },
      {
        headerName: 'Vendor ID',
        // field: 'userId',
        width: 300,
        cellRenderer: this.subgroup.bind(this),
      },
      {
        headerName: 'Email',
        field: 'email',
        width: 250,
      },

      {
        headerName: 'Phone Number',
        field: 'phone',
        width: 190,
      },
      {
        headerName: '',
        field: '',
        cellClass: 'cellAlign',
        cellRenderer: this.createElement.bind(this),
        width: 35,
        filter: false,
      },
      {
        headerName: '',
        field: '',
        cellClass: 'cellAlign',
        cellRenderer: this.deleteUser.bind(this),
        minWidth: 80,
        maxWidth: 80,
        filter: false,
      },
    ]
  },
  mounted() {
    this.vendors = this.store.assort.vendors
    // this.fetch()
  },
  methods: {
    onGridReady(params) {
      setTimeout(() => {
        params.api.redrawRows()
      }, 100)
    },
    getRowHeight(params) {
      let rowLength = 70
      let totalLen = 0
      params.data.groups?.map(app => {
        totalLen = totalLen + app.length
        // totalLen = totalLen + app.groupList.length
      })
      rowLength = rowLength + totalLen * 30
      return rowLength
    },
    // getRowHeight(params) {
    //   return params.data.rowHeight
    // },
    subgroup(event) {
      let subgrp = []
      event.data.applications.map(app => {
        if (app.groups.length && app.name === this.store.user.appName) {
          if (app.groups[0].groupList.length)
            app.groups[0].groupList.map(sb => {
              subgrp.push(sb.groupId)
            })
        }
      })
      var link = document.createElement('a')
      subgrp.map(gp => {
        link.innerHTML =
          link.innerHTML + `<i class="fa pb-2 flex text-black" >${gp}</i>`
      })
      link.addEventListener('click', () => {})
      //  if(event.data.status === 'Active'){
      return link
      // } else {
      //   return ''
      // }
    },
    group(event) {
      let grp = []
      event.data.applications.map(app => {
        if (app.groups.length && app.name === this.store.user.appName) {
          if (app.groups[0].groupList.length)
            app.groups[0].groupList.map(sb => {
              grp.push(sb.name)
            })
        }
      })

      var link = document.createElement('a')
      grp.map(gp => {
        link.innerHTML =
          link.innerHTML + `<i class="fa pb-2 mb-2 flex text-black" >${gp}</i>`
      })
      // link.innerHTML = `<div>
      //  <i class="fa pb-2 flex fa-caret-down text-black" >Display</i>
      //  </div>`
      link.addEventListener('click', () => {
        // this.store.user.condition = 'newUser'
        // this.store.user.userData = data.data.userId
      })
      //   if(event.data.status === 'Active'){
      return link
      //  } else {
      //    return ''
      //  }
    },
    newVendor() {
      this.store.user.condition = 'newVendor'
      this.store.user.userData = null
    },
    createElement(data) {
      var link = document.createElement('a')
      link.innerHTML = '<i class="fa fa-pencil"  ></i>'
      link.addEventListener('click', () => {
        this.store.user.condition = 'newVendor'
        this.store.user.userData = data.data.userId
      })
      return link
    },
    deleteUser(event) {
      var link = document.createElement('a')
      link.innerHTML = '<i class="fa fa-trash" ></i>'
      link.addEventListener('click', async () => {
        // this.$refs.delUser.open(event)
        await this.$refs.delUser.open(event.data, 'global')
        // this.store.user.condition = 'newUser'
        // this.store.user.userData = data.data.userId
      })
      return link
    },
  },
}
</script>
<style lang="scss">
// .ag-header-cell-label,
// .ag-header-row,
// .ag-theme-fresh .ag-row-odd {
//   background-color: #fff;
//   background: none;
// }
.ag-body-viewport .ag-center-cols-container,
.ag-theme-fresh .ag-body-viewpor,
.ag-center-cols-viewport,
.ag-center-cols-clipper,
.ag-center-cols-clipper,
.ag-theme-fresh .ag-row-even,
.ag-theme-fresh .ag-paging-panel,
.ag-header-viewport,
.ag-header-container,
.ag-header-cell-label,
.ag-header-row {
  background-color: #e5e5e5 !important;
}
.ag-header-cell-label .ag-header-cell-text {
  color: #050505;
  font-size: 14px;
  font-weight: 700;
}
.ag-theme-fresh .ag-root-wrapper {
  border: none;
}
.ag-theme-fresh .ag-header-cell {
  border-right: none;
}
.ag-theme-fresh .ag-header-cell::after,
.ag-theme-fresh .ag-header-group-cell::after {
  content: none;
}
.ag-row-position-absolute {
  position: relative;
  margin: 20px 0;
}
#page-size {
  width: 60px;
}
ul.nav {
  border-bottom: 2px solid #d8d8d8;
  margin-top: 20px;
  margin-bottom: 40px;
}
ul.nav li {
  display: inline-block;

  a.router-link-active {
    color: #c21a31;
    border-left: 0 !important ;
    margin-right: 20px;
    border-bottom: 2px solid;
  }
}
a {
  color: #d8d8d8;
}
img {
  float: left;
  margin: 0 5px;
}
.ag-paging-row-summary-panel {
  position: absolute;
  left: 0;
}
.ag-paging-page-summary-panel .ag-paging-button button {
  position: relative;
}
.pages {
  width: 100%;
  background-color: #e5e5e5;
}

.button-top {
  position: fixed;
  top: 22px;
  right: 35px;
}
</style>
